import {
  SET_PROJECTS,
  SEARCH,
  SET_SELECTED_PROJECT,
  SET_SELECT_PROJECT_TYPE
} from '@/system/store/mutation-types'

import {
  IProjectStore,
  IProjects,
  ISelectSystem,
  ISelectedProjects
} from '@/features/projectList/store'

import { MutationTree, Mutation } from 'vuex'

const setProjects: Mutation<IProjectStore> = (state: IProjectStore, projects: IProjects) => {
  return Object.assign(state, { projects })
}

const setSearch: Mutation<IProjectStore> = (state: IProjectStore, search: string) => {
  state.search = search
  return state
}

const setSelected: Mutation<IProjectStore> = (state: IProjectStore, selectedProjects: ISelectedProjects[]) => {
  return Object.assign(state, { selectedProjects })
}

const setSelectProjectType: Mutation<IProjectStore> = (state: IProjectStore, { value }: ISelectSystem) => {
  state.select = value
  return state
}

const mutations: MutationTree<IProjectStore> = {
  [ SET_PROJECTS ]: setProjects,
  [ SEARCH ]: setSearch,
  [ SET_SELECTED_PROJECT ]: setSelected,
  [ SET_SELECT_PROJECT_TYPE ]: setSelectProjectType
}

export default mutations
